import $ from 'jquery';
import * as infiniteHits from './load_more_results';

window.OpportunitiesSearch = {
  searchObject: {},

  initializeSearch(indexParams, searchParams) {
    this.indexParams = indexParams;
    this.searchParams = searchParams;
    this.searchObject = this._initializeSearchObject();
    this._addWidgets();
    this.searchObject.start();
    infiniteHits.loadMoreResults();
  },

  _initializeSearchObject() {
    return instantsearch({
      searchClient: algoliasearch(this.indexParams.appId, this.indexParams.key),
      indexName: this.indexParams.name,
      routing: true
    });
  },

  _addWidgets() {
    this.searchObject.addWidgets([
      instantsearch.widgets.configure(this.searchParams),
      OpportunityWidgets.opportunitiesHits(),
      OpportunityWidgets.searchBoxWidget(),
      OpportunityWidgets.statusWidget(),
      OpportunityWidgets.descriptionWidget(),
      OpportunityWidgets.dateMenuWidget('closure_date_int'),
      OpportunityWidgets.valueWidget(),
      OpportunityWidgets.ownersWidget(),
      Widgets.currentRefinedValuesWidget()(),
      Widgets.clearAllWidget(),
      Widgets.statsWidget()
    ]);
  }
};
